import { 
  collection, 
  getDocs, 
  addDoc, 
  writeBatch,
  query,
  orderBy,
  doc,
  getFirestore
} from 'firebase/firestore';
// import { db } from '../../config/firebase';
import type { RoomCategory } from '../../types';

const COLLECTION_NAME = 'room-booking';

export const roomsService = {
  async getRoomCategories(): Promise<RoomCategory[]> {
    const db = getFirestore();
    const q = query(
      collection(db, COLLECTION_NAME),
      orderBy('pricePerNight', 'asc')
    );
    
    const querySnapshot = await getDocs(q);
    return querySnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    })) as RoomCategory[];
  },

  async addRoomCategory(category: Omit<RoomCategory, 'id'>): Promise<string> {
    const db = getFirestore();
    const docRef = await addDoc(collection(db, COLLECTION_NAME), category);
    return docRef.id;
  },

  async uploadDefaultData(categories: Omit<RoomCategory, 'id'>[]): Promise<void> {
    const db = getFirestore();
    const batch = writeBatch(db);
    
    // First, get existing documents to avoid duplicates
    const existingDocs = await getDocs(collection(db, COLLECTION_NAME));
    
    // Delete existing documents
    existingDocs.docs.forEach(document => {
      batch.delete(doc(db, COLLECTION_NAME, document.id));
    });
    
    // Add new documents
    categories.forEach(category => {
      const newDocRef = doc(collection(db, COLLECTION_NAME));
      batch.set(newDocRef, category);
    });
    
    await batch.commit();
  }
};
